import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import Block from '@mui/icons-material/Block';
import { RISK_LIST_DISPLAY, RESTRICTIVE_RISK_LIST_TYPES } from '../../constants/risk-list';

const RiskListIcon = ({ riskList }) => {
  if (!riskList?.active || !RESTRICTIVE_RISK_LIST_TYPES.includes(riskList.riskListType)) {
    return null;
  }
  const { label, color } = RISK_LIST_DISPLAY[riskList.riskListType];
  return (
    <Tooltip title={`Empresa en la ${label}`}>
      <Block sx={{ width: 15, height: 15, color }} />
    </Tooltip>
  );
};

RiskListIcon.propTypes = {
  riskList: PropTypes.shape({
    riskListType: PropTypes.string,
    active: PropTypes.bool,
  }),
};

RiskListIcon.defaultProps = {
  riskList: null,
};

export default RiskListIcon;
